import { Form } from 'antd';
import { useContext, useEffect, useState } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import { toOption } from '@/utils/comUtil.js';
import SelectML from '@/components/select_ml/SelectML';

import Loading from '@/components/Loading';
import styles from './rollback.less?modules';
import { useSelector } from 'dva';
import { FunctionContext } from '../../../index';
import { message } from 'antd';
import { useDispatch } from 'dva';
const Add = (props) => {
  const [form] = Form.useForm();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['dvm/rollBack'];
  const bizData = useSelector((state) => state.dvm.approvalList);

  const { handleCancel } = props;
  const [diagramNameOption, setDiagramNameOption] = useState({});
  const { fetchData } = useContext(FunctionContext);
  const dispatch = useDispatch();
  const rollBack = (value) => {
    dispatch({
      type: 'dvm/rollBack',
      payload: {
        values: {
          ...value,
        },
      },
      callback: () => {
        message.success('已申请回滚');
        fetchData();
        handleCancel();
      },
    });
  };
  // 发起请求
  const onFinish = (values) => {
    rollBack(values);
  };
  useEffect(() => {
    if (!bizData) {
      return;
    }
    let obj = {};
    bizData.map((item) => (obj[item.diagramName] = item.diagramName));
    setDiagramNameOption(obj);
  }, [bizData]);
  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {/* 版本号 */}
          <SelectML
            height="37px"
            inputWidth="180px"
            labelwidth="130px"
            labelVal="决策图名称"
            placeVal="请选择"
            name="diagramName"
            option={toOption(diagramNameOption, true)}
            require={[
              {
                required: true,
                message: '请选择决策图名称',
              },
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="回滚"
            htmlType="submit"
            fontsize="16px"
            loading={loading}
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default Add;
